var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestDataMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "storage_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "App_Left_side_panel_logos_20px_Test_Data",
    "data-name": "App Left side panel logos_20px_Test Data",
    d: "M6,14h8v2H6Zm0-4h8v2H6ZM12,0H4A2,2,0,0,0,2,2V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V6Zm4,18H4V2h7V7h5Z",
    transform: "translate(3 2.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDataMenu);
export default __webpack_public_path__ + "static/media/test_data_menu.40203f252684fc39aa90fc702f0f3167.svg";
export { ForwardRef as ReactComponent };